import type { ApiErrorBody } from "./types";

/** Backend qaytargan xato. Matn `code` bo'yicha i18n lug'atidan olinadi (ADR 0002). */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: unknown;
  readonly requestId?: string;

  constructor(status: number, body?: ApiErrorBody) {
    super(body?.error?.message ?? `HTTP ${status}`);
    this.name = "ApiError";
    this.status = status;
    this.code = body?.error?.code ?? "INTERNAL_ERROR";
    this.details = body?.error?.details;
    this.requestId = body?.requestId;
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError;

/** Sessiya yo'q yoki tugagan — kirish sahifasiga yuborish signali. */
export const isUnauthorized = (error: unknown) => isApiError(error) && error.status === 401;

/**
 * 403 — sessiya joyida, faqat huquq yo'q. 401 dan qat'iy farq qiladi:
 * bu yerda chiqarib yuborish ishlayotgan sessiyani bekorga yo'qotadi.
 */
export const isForbidden = (error: unknown) => isApiError(error) && error.status === 403;

export const isNotFound = (error: unknown) => isApiError(error) && error.status === 404;
